import * as THREE from 'three';
import { getSceneTheme3D, type SceneTheme3D } from './sceneTheme3d.js';

export class Lighting {
  readonly ambient: THREE.AmbientLight;
  readonly directional: THREE.DirectionalLight;
  readonly fill: THREE.DirectionalLight;

  constructor(scene: THREE.Scene) {
    this.ambient = new THREE.AmbientLight(0x404060, 0.45);
    scene.add(this.ambient);

    this.directional = new THREE.DirectionalLight(0xffffff, 1.1);
    this.directional.position.set(4, 8, 6);
    this.directional.castShadow = false;
    scene.add(this.directional);

    this.fill = new THREE.DirectionalLight(0x6366f1, 0.25);
    this.fill.position.set(-3, 2, -4);
    scene.add(this.fill);
  }

  applyTheme(theme: SceneTheme3D = getSceneTheme3D()): void {
    this.ambient.color.setHex(theme.ambientColor);
    this.ambient.intensity = theme.ambientIntensity;
    this.directional.intensity = theme.directionalIntensity;
    this.fill.color.setHex(theme.fillColor);
    this.fill.intensity = theme.fillIntensity;
  }

  updateForCamera(camera: THREE.PerspectiveCamera): void {
    const dir = camera.position.clone().normalize();
    this.directional.position.copy(dir.clone().multiplyScalar(8).add(new THREE.Vector3(2, 6, 2)));
  }
}
